import React from "react";
import Card from "horizon/components/card/Card";
import UsersListHeader from "./UsersListHeader";
import UsersSearchBar from "./UsersSearchBar";
import UsersTable from "./UsersTable";
import UsersFooter from "./UsersFooter";

/**
 * Left-column list card, generic over users and groups. The parent owns the
 * browse/search state and the selection; this component only renders the
 * lightweight rows and forwards events.
 * @param {object} props
 * @param {"users"|"groups"} props.mode - Which entity the list shows
 * @param {string} props.title - Header title
 * @param {string} props.footerLabel - Footer total label
 * @param {Array} props.items - Rows to display
 * @param {boolean} props.loading - Loading flag
 * @param {string|null} props.error - Error message
 * @param {string} props.query - Search query value
 * @param {function} props.onQueryChange - Search input change handler
 * @param {string} props.roleFilter - Active role tab (for the role tag)
 * @param {number|null} props.selectedId - Selected row id
 * @param {function} props.onSelect - Row select handler (receives the row)
 * @param {function} props.onRefresh - Refresh handler
 * @param {boolean} props.showSearchPrompt - Show the "type to search" prompt
 * @returns {React.ReactElement}
 */
function UsersList({ mode, title, footerLabel, items, loading, error, query, onQueryChange,
    roleFilter, selectedId, onSelect, onRefresh, showSearchPrompt }) {
    return (
        <Card p="20px">
            <UsersListHeader refreshing={loading} onRefresh={onRefresh} title={title} />
            <UsersSearchBar searchTerm={query} loading={loading} onSearch={(e) => onQueryChange(e.target.value)} />
            <UsersTable items={items} mode={mode} loading={loading} error={error} roleFilter={roleFilter}
                selectedId={selectedId} onSelect={onSelect} showSearchPrompt={showSearchPrompt} />
            <UsersFooter count={items.length} label={footerLabel} />
        </Card>
    );
}

export default UsersList;
